import classNames from "classnames";
import { FunctionComponent } from "react";
import SkeletonCategory from "@Components/atoms/skeleton/SkeletonCategory";
import SkeletonCollection from "@Components/atoms/skeleton/SkeletonCollection";
import SkeletonItem from "@Components/atoms/skeleton/SkeletonItem";
import { HEADER_HEIGHT, HEADER_MOBILE_HEIGHT } from "@Components/organisms/Header/index";
import useBannerKountriesHeight from "@Hooks/banner/useBannerKountriesHeight";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import "./style.scss";

export const HomeSkeleton: FunctionComponent<{ loaded: boolean }> = ({ loaded }) => {
  const { isLargeScreen } = useBreakpoint();
  const headerHeight = isLargeScreen ? HEADER_HEIGHT : HEADER_MOBILE_HEIGHT;
  const bannerKountriesHeight = useBannerKountriesHeight();

  return (
    <div
      className={classNames("HomeSkeleton", { "HomeSkeleton--loaded": loaded })}
      style={{ top: headerHeight + bannerKountriesHeight }}
    >
      <div className="HomeSkeleton-wrapper">
        <div className="HomeSkeleton-hero">
          <div className="HomeSkeleton-hero-left">
            <SkeletonItem type="image" />
            <div className="HomeSkeleton-hero-content">
              <SkeletonItem type="text" width="70%" />
              <SkeletonItem type="text" width="90%" />
              <SkeletonItem type="button" width={180} />
            </div>
          </div>
          <div className="HomeSkeleton-hero-right">
            <SkeletonItem type="image" />
            <div className="HomeSkeleton-hero-content">
              <SkeletonItem type="text" width="70%" />
              <SkeletonItem type="text" width="90%" />
              <SkeletonItem type="button" width={180} />
            </div>
          </div>
        </div>
        <SkeletonItem className="HomeSkeleton-title" height={32} type="text" width={300} />

        <div className="HomeSkeleton-collections">
          <SkeletonCollection />
          <SkeletonCollection />
          <SkeletonCollection />
          <SkeletonCollection />
          <SkeletonCollection />
          <SkeletonCollection />
        </div>
        <div className="HomeSkeleton-categories">
          <SkeletonItem
            className="HomeSkeleton-categories-title"
            height={32}
            type="text"
            width="40%"
          />
          <SkeletonItem
            className="HomeSkeleton-categories-description"
            height={24}
            type="text"
            width="60%"
          />
          <div className="HomeSkeleton-categories-wrapper">
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
            <SkeletonCategory />
          </div>
        </div>
      </div>
    </div>
  );
};
